import React from 'react'
import { pluralize } from 'humanize-plus'
import cx from 'classnames'
import { compose, withHandlers } from 'recompose'
import { Select } from '@driftt/tide-core-legacy'
import style from './style.styl'

const DelayTime = ({ value, unit, updateValue, pickUnits, validRange = { min: 0 }, className }) => {
  return <div className={cx(style.delayTimeWrapper, className)}>
    <input
      type="number"
      value={value}
      min={validRange.min}
      max={validRange.max}
      step="1"
      onChange={(e) => updateValue(e.target.value)} />
    <Select
      className="units"
      options={[
        {
          value: 'hour',
          label: pluralize(value, 'Hour', 'Hours')
        },
        {
          value: 'minute',
          label: pluralize(value, 'Minute', 'Minutes')
        }]}
      value={unit}
      onChange={pickUnits}
      clearable={false}
    />
  </div>
}

export default compose(
  withHandlers({
    pickUnits: props => ({ value: unit }) => {
      props.onUnitChange(unit)
    },
    updateValue: props => value => {
      props.onValueChange(value)
    },
  }),
)(DelayTime)



// WEBPACK FOOTER //
// ./src/scripts/components/DelayTime/index.js